/* eslint-disable menti-react/forbidden-filename */
function createImage(url: string): HTMLImageElement {
  const image = new Image();
  image.src = url;
  return image;
}

export function getResizedImageUrlByWidth(imageUrl: string, width: number) {
  try {
    const url = new URL(imageUrl);

    url.searchParams.set('w', width.toString());

    return url.toString();
  } catch (e) {
    return undefined;
  }
}

function isImageElement(element: Element): element is HTMLImageElement {
  return element instanceof HTMLImageElement;
}

export function preloadChoicesImages(url: string) {
  const img = createImage(url);
  const preloadedImages = document.querySelector('.js-preloaded-images');
  if (preloadedImages) {
    const images = [
      ...document.querySelectorAll('.js-preloaded-images img'),
    ].filter(isImageElement);

    if (!images.find((image) => image.src.indexOf(url) !== -1)) {
      preloadedImages.appendChild(img);
    }
  }
}
